// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"ioKfY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S2TableLayout", ()=>S2TableLayout);
parcelHelpers.export(exports, "TableContext", ()=>TableContext);
parcelHelpers.export(exports, "TableView", ()=>TableView);
parcelHelpers.export(exports, "TableBody", ()=>TableBody);
parcelHelpers.export(exports, "Column", ()=>Column);
parcelHelpers.export(exports, "TableHeader", ()=>TableHeader);
parcelHelpers.export(exports, "Cell", ()=>Cell);
parcelHelpers.export(exports, "EditableCell", ()=>EditableCell);
parcelHelpers.export(exports, "Row", ()=>Row);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButton = require("./ActionButton");
var _reactAriaComponents = require("react-aria-components");
var _checkbox = require("./Checkbox");
var _s2IconCheckmark20NSvg = require("../s2wf-icons/S2_Icon_Checkmark_20_N.svg");
var _s2IconCheckmark20NSvgDefault = parcelHelpers.interopDefault(_s2IconCheckmark20NSvg);
var _chevron = require("../ui-icons/Chevron");
var _chevronDefault = parcelHelpers.interopDefault(_chevron);
var _s2IconClose20NSvg = require("../s2wf-icons/S2_Icon_Close_20_N.svg");
var _s2IconClose20NSvgDefault = parcelHelpers.interopDefault(_s2IconClose20NSvg);
var _utils = require("@react-aria/utils");
var _icon = require("./Icon");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _menu = require("./Menu");
var _s2MoveHorizontalTableWidgetSvg = require("../ui-icons/S2_MoveHorizontalTableWidget.svg");
var _s2MoveHorizontalTableWidgetSvgDefault = parcelHelpers.interopDefault(_s2MoveHorizontalTableWidgetSvg);
var _progressCircle = require("./ProgressCircle");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _s2IconSortDown20NSvg = require("../s2wf-icons/S2_Icon_SortDown_20_N.svg");
var _s2IconSortDown20NSvgDefault = parcelHelpers.interopDefault(_s2IconSortDown20NSvg);
var _s2IconSortUp20NSvg = require("../s2wf-icons/S2_Icon_SortUp_20_N.svg");
var _s2IconSortUp20NSvgDefault = parcelHelpers.interopDefault(_s2IconSortUp20NSvg);
var _actionBar = require("./ActionBar");
var _utils1 = require("@react-spectrum/utils");
var _i18N = require("@react-aria/i18n");
var _utils2 = require("./utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
var _reactAria = require("react-aria");
let InternalTableContext = /*#__PURE__*/ (0, _react.createContext)({});
const tableWrapper = function anonymous(props, overrides) {
    let rules = " ";
    let minHeight = false;
    let minWidth = false;
    let position = false;
    let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "M") minHeight = true;
        if (p[1] === "N") minWidth = true;
        if (p[1] === "_P") position = true;
        rules += p[0];
    }
    if (!minHeight) rules += ' Ma12';
    if (!minWidth) rules += ' Na12';
    rules += ' sd12';
    rules += ' _Bb12';
    rules += ' __ca12';
    if (!position) rules += ' _Pc12';
    rules += ' _Nb12';
    rules += ' Pb12';
    return rules;
};
const table = function anonymous(props) {
    let rules = " ";
    rules += ' Za12';
    rules += ' Fb12';
    rules += ' _oa12';
    rules += ' _4c12';
    rules += ' Ma12';
    rules += ' Na12';
    rules += ' uk12';
    rules += ' uch12';
    rules += ' udi12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    rules += ' xb12';
    rules += ' _xa12';
    rules += ' _Na12';
    rules += ' Pa12';
    if (props.isQuiet) rules += ' g912';
    else rules += ' gX12';
    rules += ' gla12';
    rules += ' iq12';
    rules += ' _jf12';
    if (props.isQuiet) rules += ' _ka12';
    else rules += ' _kb12';
    if (props.isQuiet) rules += ' ha12';
    else rules += ' hb12';
    if (props.isQuiet) rules += ' ma12';
    else rules += ' mb12';
    if (props.isQuiet) rules += ' la12';
    else rules += ' lb12';
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Ka12';
    if (props.isQuiet) rules += ' od12';
    else rules += ' of12';
    if (props.isQuiet) rules += ' nd12';
    else rules += ' nf12';
    if (props.isQuiet) rules += ' kd12';
    else rules += ' kf12';
    if (props.isQuiet) rules += ' jd12';
    else rules += ' jf12';
    rules += ' _Um12';
    if (props.isCheckboxSelection) rules += ' _Tk12';
    return rules;
};
// component-height-100
const DEFAULT_HEADER_HEIGHT = {
    medium: 32,
    large: 40
};
const ROW_HEIGHTS = {
    compact: {
        medium: 32,
        large: 40
    },
    regular: {
        medium: 40,
        large: 50
    },
    spacious: {
        medium: 48,
        large: 60
    }
};
class S2TableLayout extends (0, _reactAriaComponents.TableLayout) {
    isStickyColumn(node) {
        return node.props.isSticky;
    }
    buildCollection() {
        let [header, body] = super.buildCollection();
        if (!header) return [];
        let { layoutInfo } = body;
        // TableLayout's buildCollection always sets the body width to the max width between the header width, but
        // we want the body to be sticky and only as wide as the table so it is always in view if loading/empty
        let isEmptyOrLoading = this.virtualizer?.collection.size === 0;
        if (isEmptyOrLoading) layoutInfo.rect.width = this.virtualizer.visibleRect.width - 80;
        return [
            header,
            body
        ];
    }
    buildLoader(node, x, y) {
        let layoutNode = super.buildLoader(node, x, y);
        let { layoutInfo } = layoutNode;
        layoutInfo.allowOverflow = true;
        layoutInfo.rect.width = this.virtualizer.visibleRect.width;
        // If performing first load or empty, the body will be sticky so we don't want to apply sticky to the loader, otherwise it will
        // affect the positioning of the empty state renderer
        let collection = this.virtualizer.collection;
        let isEmptyOrLoading = collection?.size === 0;
        layoutInfo.isSticky = !isEmptyOrLoading;
        return layoutNode;
    }
    // y is the height of the headers
    buildBody(y) {
        let layoutNode = super.buildBody(y);
        let { layoutInfo } = layoutNode;
        // Needs overflow for sticky loader
        layoutInfo.allowOverflow = true;
        // If loading or empty, we'll want the body to be sticky and centered
        let isEmptyOrLoading = this.virtualizer?.collection.size === 0;
        if (isEmptyOrLoading) {
            layoutInfo.rect = new (0, _reactAriaComponents.Rect)(40, 40, this.virtualizer.visibleRect.width - 80, this.virtualizer.visibleRect.height - 80);
            layoutInfo.isSticky = true;
        }
        return {
            ...layoutNode,
            layoutInfo
        };
    }
    buildRow(node, x, y) {
        let layoutNode = super.buildRow(node, x, y);
        layoutNode.layoutInfo.allowOverflow = true;
        // Needs overflow for sticky selection/drag cells
        return layoutNode;
    }
    buildTableHeader() {
        let layoutNode = super.buildTableHeader();
        // Needs overflow for sticky selection/drag column
        layoutNode.layoutInfo.allowOverflow = true;
        return layoutNode;
    }
    buildColumn(node, x, y) {
        let layoutNode = super.buildColumn(node, x, y);
        // Needs overflow for the resize handle
        layoutNode.layoutInfo.allowOverflow = true;
        return layoutNode;
    }
}
const TableContext = /*#__PURE__*/ (0, _react.createContext)(null);
const TableView = /*#__PURE__*/ (0, _react.forwardRef)(function TableView(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, TableContext);
    let { UNSAFE_style, UNSAFE_className, isQuiet = false, density = 'regular', overflowMode = 'truncate', styles, loadingState, onResize: propsOnResize, onResizeStart: propsOnResizeStart, onResizeEnd: propsOnResizeEnd, onAction, onLoadMore, selectionMode = 'none', ...otherProps } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    let scale = (0, _utils2.useScale)();
    // Starts when the user selects resize from the menu, ends when resizing ends
    // used to control the visibility of the resizer Nubbin
    let [isInResizeMode, setIsInResizeMode] = (0, _react.useState)(false);
    let onResizeStart = (0, _react.useCallback)((widths)=>{
        propsOnResizeStart?.(widths);
    }, [
        propsOnResizeStart
    ]);
    let onResizeEnd = (0, _react.useCallback)((widths)=>{
        setIsInResizeMode(false);
        propsOnResizeEnd?.(widths);
    }, [
        propsOnResizeEnd,
        setIsInResizeMode
    ]);
    let context = (0, _react.useMemo)(()=>({
            isQuiet,
            density,
            overflowMode,
            loadingState,
            onLoadMore,
            isInResizeMode,
            setIsInResizeMode,
            selectionMode
        }), [
        isQuiet,
        density,
        overflowMode,
        loadingState,
        onLoadMore,
        isInResizeMode,
        setIsInResizeMode,
        selectionMode
    ]);
    let scrollRef = (0, _react.useRef)(null);
    let isCheckboxSelection = selectionMode === 'multiple' || selectionMode === 'single';
    let { selectedKeys, onSelectionChange, actionBar, actionBarHeight } = (0, _actionBar.useActionBarContainer)({
        ...props,
        scrollRef
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.ResizableTableContainer), {
        // TODO: perhaps this ref should be attached to the RACTable but it expects a table type ref which isn't true in the virtualized case
        ref: domRef,
        onResize: propsOnResize,
        onResizeEnd: onResizeEnd,
        onResizeStart: onResizeStart,
        className: (UNSAFE_className || '') + tableWrapper(null, styles),
        style: UNSAFE_style,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Virtualizer), {
                layout: S2TableLayout,
                layoutOptions: {
                    rowHeight: overflowMode === 'wrap' ? undefined : ROW_HEIGHTS[density][scale],
                    estimatedRowHeight: overflowMode === 'wrap' ? ROW_HEIGHTS[density][scale] : undefined,
                    // No need for estimated headingHeight since the headers aren't affected by overflow mode: wrap
                    headingHeight: DEFAULT_HEADER_HEIGHT[scale],
                    loaderHeight: 60
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalTableContext.Provider, {
                    value: context,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Table), {
                        ref: scrollRef,
                        style: {
                            // Fix webkit bug where scrollbars appear above the checkboxes/other table elements
                            WebkitTransform: 'translateZ(0)',
                            // Add padding at the bottom when the action bar is visible so users can scroll to the last items.
                            // Also add scroll padding so navigating with the keyboard doesn't go behind the action bar.
                            paddingBottom: actionBarHeight > 0 ? actionBarHeight + 8 : 0,
                            scrollPaddingBottom: actionBarHeight > 0 ? actionBarHeight + 8 : 0
                        },
                        className: (renderProps)=>table({
                                ...renderProps,
                                isCheckboxSelection,
                                isQuiet
                            }),
                        selectionBehavior: "toggle",
                        selectionMode: selectionMode,
                        onRowAction: onAction,
                        ...otherProps,
                        selectedKeys: selectedKeys,
                        defaultSelectedKeys: undefined,
                        onSelectionChange: onSelectionChange
                    })
                })
            }),
            actionBar
        ]
    });
});
const centeredWrapper = " sd12 eb12 _Ca12 Za12 Fb12";
const TableBody = /*#__PURE__*/ (0, _react.forwardRef)(function TableBody(props, ref) {
    let { items, renderEmptyState, children, dependencies = [] } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    let { loadingState, onLoadMore } = (0, _react.useContext)(InternalTableContext);
    let isLoading = loadingState === 'loading' || loadingState === 'loadingMore';
    let emptyRender;
    let renderer = children;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    // TODO: still is offset strangely if loadingMore when there aren't any items in the table, see http://localhost:6006/?path=/story/tableview--empty-state&args=loadingState:loadingMore
    // This is because we don't distinguish between loadingMore and loading in the layout, resulting in a different rect being used to build the body. Perhaps can be considered as a user error
    // if they pass loadingMore without having any other items in the table. Alternatively, could update the layout so it knows the current loading state.
    let loadMoreSpinner = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TableLoadMoreItem), {
        isLoading: loadingState === 'loadingMore',
        onLoadMore: onLoadMore,
        className: " Fb12 Za12",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: centeredWrapper,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
                isIndeterminate: true,
                "aria-label": stringFormatter.format('table.loadingMore')
            })
        })
    });
    // If the user is rendering their rows in dynamic fashion, wrap their render function in Collection so we can inject
    // the loader. Otherwise it is a static renderer and thus we can simply add the table loader after
    // TODO: this assumes that the user isn't providing their children in some wrapper though and/or isn't doing a map of children
    // (though I guess they wouldn't provide items then so the check for this is still valid in the latter case)...
    if (typeof children === 'function' && items) renderer = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                items: items,
                dependencies: dependencies,
                children: children
            }),
            loadMoreSpinner
        ]
    });
    else renderer = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            children,
            loadMoreSpinner
        ]
    });
    if (renderEmptyState != null && !isLoading) emptyRender = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: centeredWrapper,
            children: renderEmptyState(props)
        });
    else if (loadingState === 'loading') emptyRender = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: centeredWrapper,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
                isIndeterminate: true,
                "aria-label": stringFormatter.format('table.loading')
            })
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TableBody), {
        // @ts-ignore
        ref: domRef,
        className: " Fb12",
        ...props,
        renderEmptyState: emptyRender,
        dependencies: [
            loadingState
        ],
        children: renderer
    });
});
const cellFocus = {
    outlineStyle: {
        default: 'none',
        isFocusVisible: 'solid'
    },
    outlineOffset: -2,
    outlineWidth: 2,
    outlineColor: 'focus-ring',
    borderRadius: '[6px]'
};
function CellFocusRing() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        role: "presentation",
        className: function anonymous(props) {
            let rules = " ";
            if (props.isFocusVisible) rules += ' _Lf12';
            else rules += ' _Le12';
            rules += ' _Kb12';
            rules += ' _Mc12';
            rules += ' Oh12';
            rules += ' of12';
            rules += ' nf12';
            rules += ' kf12';
            rules += ' jf12';
            rules += ' _Pa12';
            rules += ' Wr12';
            rules += ' _lr12';
            rules += ' _Ar12';
            rules += ' _zr12';
            rules += ' _Ob12';
            return rules;
        }({
            isFocusVisible: true
        })
    });
}
const columnStyles = function anonymous(props) {
    let rules = " ";
    rules += ' F40ub4c12';
    rules += ' _oa12';
    if (props.isPressed) rules += ' po12';
    else if (props.isFocusVisible) rules += ' po12';
    else if (props.isHovered) rules += ' po12';
    else rules += ' pt12';
    rules += ' plb12';
    if (props.isMenu) rules += ' Sd12';
    else rules += ' Sf12';
    if (props.isMenu) rules += ' Rd12';
    else rules += ' Rf12';
    if (props.align === "end") rules += ' _Wb12';
    else if (props.align === "center") rules += ' _Wa12';
    else if (props.align === "start") rules += ' _Wd12';
    rules += ' _Le12';
    rules += ' _Pc12';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    } else {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    }
    rules += ' uk12';
    rules += ' uch12';
    rules += ' udi12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    rules += ' xd12';
    rules += ' _xa12';
    rules += ' xX0cczbc12';
    rules += ' _xX0cczba12';
    rules += ' sd12';
    rules += ' iq12';
    rules += ' ila12';
    if (props.isQuiet) rules += ' _kb12';
    else rules += ' _ka12';
    rules += ' hb12';
    rules += ' ma12';
    if (props.isMenu) rules += ' lb12';
    else rules += ' la12';
    rules += ' _jf12';
    rules += ' _yb12';
    return rules;
};
const Column = /*#__PURE__*/ (0, _react.forwardRef)(function Column(props, ref) {
    let { isQuiet } = (0, _react.useContext)(InternalTableContext);
    let { allowsResizing, children, align = 'start' } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    let isMenu = allowsResizing || !!props.menuItems;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Column), {
        ...props,
        ref: domRef,
        style: {
            borderInlineEndColor: 'transparent'
        },
        className: (renderProps)=>columnStyles({
                ...renderProps,
                isMenu,
                align,
                isQuiet
            }),
        children: ({ allowsSorting, sortDirection, isFocusVisible, sort, startResize })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    isFocusVisible && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CellFocusRing, {}),
                    isMenu ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColumnWithMenu, {
                        isColumnResizable: allowsResizing,
                        menuItems: props.menuItems,
                        allowsSorting: allowsSorting,
                        sortDirection: sortDirection,
                        sort: sort,
                        startResize: startResize,
                        align: align,
                        children: children
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColumnContents, {
                        allowsSorting: allowsSorting,
                        sortDirection: sortDirection,
                        children: children
                    })
                ]
            })
    });
});
const columnContentWrapper = " Na12 sd12 eb12 Za12";
const sortIcon = function anonymous(props) {
    let rules = " ";
    rules += ' ZXJkxGe12';
    rules += ' FXJkxGe12';
    rules += ' _va12';
    if (props.isButton) {
        rules += ' Ht12';
        rules += ' Hsu12';
    } else rules += ' Hv12';
    rules += ' _5b12';
    rules += ' -_8sjo0b-t5ZbAob12';
    return rules;
};
function ColumnContents(props) {
    let { allowsSorting, sortDirection, children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: columnContentWrapper,
        children: [
            allowsSorting && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                values: [
                    [
                        (0, _icon.IconContext),
                        {
                            styles: sortIcon({})
                        }
                    ]
                ],
                children: sortDirection != null && (sortDirection === 'ascending' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconSortUp20NSvgDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconSortDown20NSvgDefault.default), {}))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: " _Nc12 Pc12 _Yb12 _7c12 Za12",
                children: children
            })
        ]
    });
}
const resizableMenuButtonWrapper = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' _Kb12';
    rules += ' _Mc12';
    rules += ' Oh12';
    rules += ' of12';
    rules += ' nf12';
    rules += ' kf12';
    rules += ' jf12';
    rules += ' pt12';
    rules += ' Za12';
    rules += ' _Pc12';
    rules += ' sd12';
    rules += ' eb12';
    if (props.align === "end") rules += ' _Cb12';
    else if (props.align === "center") rules += ' _Ca12';
    else if (props.align === "default") rules += ' _Cg12';
    rules += ' Sf12';
    rules += ' Rf12';
    rules += ' g912';
    rules += ' _je12';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    } else {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    }
    rules += ' uk12';
    rules += ' uch12';
    rules += ' udi12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    rules += ' xd12';
    rules += ' _xa12';
    rules += ' xX0cczbc12';
    rules += ' _xX0cczba12';
    return rules;
};
const resizerHandleContainer = function anonymous(props) {
    let rules = " ";
    if (props.isInResizeMode) rules += ' sb12';
    else if (props.isResizing) rules += ' sb12';
    else rules += ' sjBAxlb12';
    rules += ' Zj12';
    rules += ' Fb12';
    rules += ' _Pa12';
    rules += ' Wr12';
    rules += ' _zdYbyj12';
    if (props.resizableDirection === "both") rules += ' rk12';
    else if (props.resizableDirection === "right") rules += ' rF12';
    else if (props.resizableDirection === "left") rules += ' rj12';
    else rules += ' rt12';
    return rules;
};
const resizerHandle = function anonymous(props) {
    let rules = " ";
    if (props.isResizing) rules += ' g5qAiPc12';
    else if (props.isFocusVisible) rules += ' g5qAiPc12';
    else rules += ' gE12';
    if (props.isResizing) rules += ' gle12';
    else if (props.isFocusVisible) rules += ' gle12';
    else rules += ' gla12';
    if (props.isResizing) rules += ' Fc12';
    else rules += ' Fb12';
    if (props.isResizing) rules += ' Zf12';
    else rules += ' Ze12';
    rules += ' _Pa12';
    rules += ' _AWJpoB12';
    return rules;
};
const columnHeaderText = " _Nc12 Pc12 _Yb12 _7c12 NXJkxGe12 _ua12 _vb12 _sd12";
const chevronIcon = " _Sd12 It12 Isu12 NXJkxGe12 _va12 -_8sjo0b-t5ZbAob12";
const nubbin = " _Pa12 Wr12 _AlhfIS12 ZXJkxGe12 FXJkxGe12 t5qAiPc12 tla12 -_8sjo0b-tw12 -_8sjo0b-lt8pvGJ12";
function ColumnWithMenu(props) {
    let { allowsSorting, sortDirection, sort, startResize, children, align, isColumnResizable, menuItems } = props;
    let { setIsInResizeMode, isInResizeMode } = (0, _react.useContext)(InternalTableContext);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    const onMenuSelect = (key)=>{
        switch(key){
            case 'sort-asc':
                sort('ascending');
                break;
            case 'sort-desc':
                sort('descending');
                break;
            case 'resize':
                setIsInResizeMode?.(true);
                startResize();
                break;
        }
    };
    let items = (0, _react.useMemo)(()=>{
        let options = [];
        if (isColumnResizable) options = [
            {
                label: stringFormatter.format('table.resizeColumn'),
                id: 'resize'
            }
        ];
        if (allowsSorting) options = [
            {
                label: stringFormatter.format('table.sortAscending'),
                id: 'sort-asc'
            },
            {
                label: stringFormatter.format('table.sortDescending'),
                id: 'sort-desc'
            },
            ...options
        ];
        return options;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allowsSorting,
        isColumnResizable
    ]);
    let buttonAlignment = 'start';
    let menuAlign = 'start';
    if (align === 'center') buttonAlignment = 'center';
    else if (align === 'end') {
        buttonAlignment = 'end';
        menuAlign = 'end';
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuTrigger), {
                align: menuAlign,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Button), {
                        className: (renderProps)=>resizableMenuButtonWrapper({
                                ...renderProps,
                                align: buttonAlignment
                            }),
                        children: [
                            allowsSorting && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                                values: [
                                    [
                                        (0, _icon.IconContext),
                                        {
                                            styles: sortIcon({
                                                isButton: true
                                            })
                                        }
                                    ]
                                ],
                                children: sortDirection != null && (sortDirection === 'ascending' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconSortUp20NSvgDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconSortDown20NSvgDefault.default), {}))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: columnHeaderText,
                                children: children
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
                                size: "M",
                                className: chevronIcon
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.Menu), {
                        onAction: onMenuSelect,
                        styles: " Nn12",
                        children: [
                            items.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuSection), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                                    items: items,
                                    children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
                                            children: item?.label
                                        })
                                })
                            }),
                            menuItems
                        ]
                    })
                ]
            }),
            isColumnResizable && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                "data-react-aria-prevent-focus": "true",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColumnResizer), {
                    "data-react-aria-prevent-focus": "true",
                    className: ({ resizableDirection, isResizing })=>resizerHandleContainer({
                            resizableDirection,
                            isResizing,
                            isInResizeMode
                        }),
                    children: ({ isFocusVisible, isResizing })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(ResizerIndicator, {
                                    isFocusVisible: isFocusVisible,
                                    isResizing: isResizing
                                }),
                                (isFocusVisible || isInResizeMode) && isResizing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: nubbin,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2MoveHorizontalTableWidgetSvgDefault.default), {})
                                })
                            ]
                        })
                })
            })
        ]
    });
}
function ResizerIndicator({ isFocusVisible, isResizing }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: resizerHandle({
            isFocusVisible,
            isResizing
        })
    });
}
const tableHeader = function anonymous(props) {
    let rules = " ";
    rules += ' Fb12';
    rules += ' Za12';
    rules += ' gL12';
    rules += ' JLPOtrc12';
    if (props.isHovered) rules += ' -xLp2wc-sb12';
    else rules += ' -xLp2wc-sk12';
    return rules;
};
const selectAllCheckbox = " IC12";
const selectAllCheckboxColumn = function anonymous(props) {
    let rules = " ";
    rules += ' Td12';
    rules += ' Qd12';
    rules += ' Sd12';
    rules += ' Rd12';
    rules += ' Fb12';
    rules += ' _oa12';
    rules += ' _Le12';
    rules += ' _Pc12';
    rules += ' _cb12';
    rules += ' iq12';
    rules += ' ila12';
    rules += ' ma12';
    rules += ' la12';
    if (props.isQuiet) rules += ' _kb12';
    else rules += ' _ka12';
    rules += ' hb12';
    rules += ' _jf12';
    rules += ' gL12';
    return rules;
};
const TableHeader = /*#__PURE__*/ (0, _react.forwardRef)(function TableHeader({ columns, dependencies, children }, ref) {
    let scale = (0, _utils2.useScale)();
    let { selectionBehavior, selectionMode } = (0, _reactAriaComponents.useTableOptions)();
    let { isQuiet } = (0, _react.useContext)(InternalTableContext);
    let domRef = (0, _utils1.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TableHeader), {
        // @ts-ignore
        ref: domRef,
        className: tableHeader,
        children: [
            selectionBehavior === 'toggle' && // Also isSticky prop is applied just for the layout, will decide what the RAC api should be later
            // @ts-ignore
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Column), {
                isSticky: true,
                width: scale === 'medium' ? 40 : 52,
                minWidth: scale === 'medium' ? 40 : 52,
                className: selectAllCheckboxColumn({
                    isQuiet
                }),
                children: ({ isFocusVisible })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            selectionMode === 'single' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    isFocusVisible && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CellFocusRing, {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(VisuallyHiddenSelectAllLabel, {})
                                ]
                            }),
                            selectionMode === 'multiple' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                                isEmphasized: true,
                                styles: selectAllCheckbox,
                                slot: "selection"
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                items: columns,
                dependencies: dependencies,
                children: children
            })
        ]
    });
});
function VisuallyHiddenSelectAllLabel() {
    let checkboxProps = (0, _reactAriaComponents.useSlottedContext)((0, _reactAriaComponents.CheckboxContext), 'selection');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAria.VisuallyHidden), {
        children: checkboxProps?.['aria-label']
    });
}
const commonCellStyles = {
    borderColor: 'transparent',
    borderBottomWidth: 1,
    borderTopWidth: 0,
    borderXWidth: 0,
    borderStyle: 'solid',
    position: 'relative',
    color: {
        default: 'gray-800',
        forcedColors: 'ButtonText'
    },
    outlineStyle: 'none',
    paddingX: 16 // table-edge-to-content
};
const cell = function anonymous(props) {
    let rules = " ";
    rules += ' iq12';
    rules += ' ila12';
    rules += ' hXMFGYc12';
    rules += ' _kJ8iPYd12';
    rules += ' ma12';
    if (props.isDivider) rules += ' lb12';
    else rules += ' la12';
    if (props.isDivider) rules += ' _jf12';
    else rules += ' _je12';
    rules += ' _Pc12';
    if (props.isPressed) rules += ' po12';
    else if (props.isFocusVisible) rules += ' po12';
    else if (props.isHovered) rules += ' po12';
    else rules += ' pt12';
    rules += ' _Le12';
    rules += ' Sf12';
    rules += ' Rf12';
    rules += ' Tu7Fubd12';
    rules += ' Qu7Fubd12';
    rules += ' MAyFGYc12';
    rules += ' _oa12';
    rules += ' Fb12';
    rules += ' Za12';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    } else {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    }
    rules += ' eb12';
    rules += ' sd12';
    if (props.density === "spacious") rules += ' -M_-Mk12';
    else if (props.density === "compact") rules += ' -M_-Mi12';
    else rules += ' -M_-Mh12';
    rules += ' -_k_-_ka12';
    rules += ' -h_-hb12';
    return rules;
};
const stickyCell = {
    backgroundColor: 'gray-25'
};
const checkboxCellStyle = " iA12 ha12 _ka12 ma12 la12 _jf12 _Pc12 pt12 plb12 _Le12 Sf12 Rf12 gs9yXOb12 _cb12 FBJsHLe12";
const cellContent = function anonymous(props) {
    let rules = " ";
    rules += ' _Nc12';
    rules += ' Pc12';
    rules += ' _Yb12';
    if (props.overflowMode === "wrap") rules += ' _7b12';
    else rules += ' _7c12';
    if (props.align === "end") rules += ' _Wb12';
    else if (props.align === "center") rules += ' _Wa12';
    else if (props.align === "start") rules += ' _Wd12';
    rules += ' Za12';
    rules += ' _Bb12';
    if (props.isSticky) rules += ' Td12';
    else rules += ' Tp12';
    if (props.isSticky) rules += ' Qd12';
    else rules += ' Qp12';
    if (props.isSticky) rules += ' Sd12';
    else rules += ' Sp12';
    if (props.isSticky) rules += ' Rd12';
    else rules += ' Rp12';
    if (props.isSticky) rules += ' Jy12';
    else rules += ' Jb12';
    if (props.isSticky) rules += ' Gy12';
    else rules += ' Gb12';
    if (props.isSticky) rules += ' Iy12';
    else rules += ' Ib12';
    if (props.isSticky) rules += ' Hy12';
    else rules += ' Hb12';
    if (props.isSticky) rules += ' gs9yXOb12';
    else rules += ' g912';
    return rules;
};
const Cell = /*#__PURE__*/ (0, _react.forwardRef)(function Cell(props, ref) {
    let { children, isSticky, showDivider = false, align, textValue, ...otherProps } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    let tableVisualOptions = (0, _react.useContext)(InternalTableContext);
    textValue ||= typeof children === 'string' ? children : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
        ref: domRef,
        // Also isSticky prop is applied just for the layout, will decide what the RAC api should be later
        // @ts-ignore
        isSticky: isSticky,
        className: (renderProps)=>cell({
                ...renderProps,
                ...tableVisualOptions,
                isDivider: showDivider
            }),
        textValue: textValue,
        ...otherProps,
        children: ({ isFocusVisible })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: cellContent({
                            ...tableVisualOptions,
                            isSticky,
                            align: align || 'start'
                        }),
                        children: children
                    }),
                    isFocusVisible && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CellFocusRing, {})
                ]
            })
    });
});
const editableCell = function anonymous(props) {
    let rules = " ";
    rules += ' iq12';
    rules += ' ila12';
    rules += ' hXMFGYc12';
    rules += ' _kJ8iPYd12';
    rules += ' ma12';
    if (props.isDivider) rules += ' lb12';
    else rules += ' la12';
    if (props.isDivider) rules += ' _jf12';
    else rules += ' _je12';
    rules += ' _Pc12';
    if (props.isSaving) {
        if (props.isPressed) rules += ' pt12';
        else if (props.isFocusVisible) rules += ' pt12';
        else if (props.isHovered) rules += ' pt12';
        else rules += ' pv12';
    } else {
        if (props.isPressed) rules += ' po12';
        else if (props.isFocusVisible) rules += ' po12';
        else if (props.isHovered) rules += ' po12';
        else rules += ' pt12';
    }
    rules += ' _Le12';
    rules += ' Sf12';
    rules += ' Rf12';
    rules += ' Tu7Fubd12';
    rules += ' Qu7Fubd12';
    rules += ' _oa12';
    rules += ' FBJsHLe12';
    rules += ' Za12';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    } else {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    }
    rules += ' eb12';
    rules += ' sd12';
    rules += ' g912';
    if (props.selectionMode === "multiple") rules += ' gf2iZndX12';
    else if (props.selectionMode === "single") rules += ' gf2iZndX12';
    else if (props.selectionMode === "none") rules += ' gf2iZndj1B7i12';
    rules += ' gDJ7W0cX12';
    rules += ' -_k_-_ka12';
    rules += ' -h_-hb12';
    return rules;
};
let editPopover = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        rules += p[0];
    }
    if (props.colorScheme === "dark") rules += ' _pa12';
    else if (props.colorScheme === "light") rules += ' _pb12';
    else if (props.colorScheme === "light dark") rules += ' _pc12';
    else rules += ' _pN79Hzc12';
    rules += ' -Ovbhqd-g_g12';
    rules += ' gEzkoQe12';
    rules += ' kb12';
    rules += ' jb12';
    rules += ' _nLeasBb12';
    rules += ' _jf12';
    rules += ' _kb12';
    rules += ' hb12';
    rules += ' mb12';
    rules += ' lb12';
    rules += ' ir12';
    rules += ' ila12';
    rules += ' _ob12';
    rules += ' _Bb12';
    if (props.isExiting) rules += ' _Ob12';
    rules += ' _Le12';
    if (!minWidth) rules += ' NuHSBze12';
    rules += ' Tt12';
    rules += ' Qt12';
    rules += ' St12';
    rules += ' Rt12';
    rules += ' sd12';
    rules += ' eb12';
    return rules;
};
const EditableCell = /*#__PURE__*/ (0, _react.forwardRef)(function EditableCell(props, ref) {
    let { children, showDivider = false, textValue, isSaving, ...otherProps } = props;
    let tableVisualOptions = (0, _react.useContext)(InternalTableContext);
    let domRef = (0, _utils.useObjectRef)(ref);
    textValue ||= typeof children === 'string' ? children : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
        ref: domRef,
        className: (renderProps)=>editableCell({
                ...renderProps,
                ...tableVisualOptions,
                isDivider: showDivider,
                isSaving
            }),
        textValue: textValue,
        ...otherProps,
        children: ({ isFocusVisible })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(EditableCellInner, {
                ...props,
                isFocusVisible: isFocusVisible,
                cellRef: domRef
            })
    });
});
const nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
function EditableCellInner(props1) {
    let { children, align, renderEditing, isSaving, onSubmit, isFocusVisible, cellRef } = props1;
    let [isOpen, setIsOpen] = (0, _react.useState)(false);
    let popoverRef = (0, _react.useRef)(null);
    let formRef = (0, _react.useRef)(null);
    let [triggerWidth, setTriggerWidth] = (0, _react.useState)(0);
    let [tableWidth, setTableWidth] = (0, _react.useState)(0);
    let [verticalOffset, setVerticalOffset] = (0, _react.useState)(0);
    let tableVisualOptions = (0, _react.useContext)(InternalTableContext);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    let { density } = (0, _react.useContext)(InternalTableContext);
    let size = 'M';
    if (density === 'compact') size = 'S';
    else if (density === 'spacious') size = 'L';
    // Popover positioning
    (0, _utils.useLayoutEffect)(()=>{
        if (!isOpen) return;
        let width = cellRef.current?.clientWidth || 0;
        let cell = cellRef.current;
        let boundingRect = cell?.parentElement?.getBoundingClientRect();
        let verticalOffset = (boundingRect?.top ?? 0) - (boundingRect?.bottom ?? 0);
        let tableWidth = cellRef.current?.closest('[role="grid"]')?.clientWidth || 0;
        setTriggerWidth(width);
        setVerticalOffset(verticalOffset);
        setTableWidth(tableWidth);
    }, [
        cellRef,
        density,
        isOpen
    ]);
    // Auto select the entire text range of the autofocused input on overlay opening
    // Maybe replace with FocusScope or one of those utilities
    (0, _react.useEffect)(()=>{
        if (isOpen) {
            let activeElement = (0, _utils.getActiveElement)((0, _utils.getOwnerDocument)(formRef.current));
            if (activeElement && formRef.current?.contains(activeElement) && (activeElement instanceof HTMLInputElement && !nonTextInputTypes.has(activeElement.type) || activeElement instanceof HTMLTextAreaElement) && typeof activeElement.select === 'function') activeElement.select();
        }
    }, [
        isOpen
    ]);
    let cancel = ()=>{
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Provider), {
        values: [
            [
                (0, _reactAriaComponents.ButtonContext),
                null
            ],
            [
                (0, _actionButton.ActionButtonContext),
                {
                    slots: {
                        [(0, _reactAriaComponents.DEFAULT_SLOT)]: {},
                        edit: {
                            onPress: ()=>setIsOpen(true),
                            isPending: isSaving,
                            isQuiet: !isSaving,
                            size,
                            excludeFromTabOrder: true,
                            styles: function anonymous(props) {
                                let rules = " ";
                                if (props.isForcedVisible) rules += ' _6c12';
                                else rules += ' _6b12';
                                rules += ' _6JGzCfcc12';
                                rules += ' _6hcIDbbc12';
                                rules += ' _6sc12';
                                return rules;
                            }({
                                isForcedVisible: isOpen || !!isSaving
                            })
                        }
                    }
                }
            ]
        ],
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: cellContent({
                    ...tableVisualOptions,
                    align: align || 'start'
                }),
                children: children
            }),
            isFocusVisible && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CellFocusRing, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                values: [
                    [
                        (0, _actionButton.ActionButtonContext),
                        null
                    ]
                ],
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Popover), {
                    isOpen: isOpen,
                    onOpenChange: setIsOpen,
                    ref: popoverRef,
                    shouldCloseOnInteractOutside: ()=>{
                        if (!popoverRef.current?.contains(document.activeElement)) return false;
                        formRef.current?.requestSubmit();
                        return false;
                    },
                    triggerRef: cellRef,
                    "aria-label": stringFormatter.format('table.editCell'),
                    offset: verticalOffset,
                    placement: "bottom start",
                    style: {
                        minWidth: `min(${triggerWidth}px, ${tableWidth}px)`,
                        maxWidth: `${tableWidth}px`,
                        // Override default z-index from useOverlayPosition. We use isolation: isolate instead.
                        zIndex: undefined
                    },
                    className: editPopover,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                        values: [
                            [
                                (0, _reactAriaComponents.OverlayTriggerStateContext),
                                null
                            ]
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Form), {
                            ref: formRef,
                            onSubmit: (e)=>{
                                e.preventDefault();
                                onSubmit();
                                setIsOpen(false);
                            },
                            className: " Za12 sd12 ed12 Ul12 ql12",
                            style: {
                                '--input-width': `calc(${triggerWidth}px - 32px)`
                            },
                            children: [
                                renderEditing(),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: " sd12 _tc12 ea12 _va12 _ua12",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButton.ActionButton), {
                                            isQuiet: true,
                                            onPress: cancel,
                                            "aria-label": stringFormatter.format('table.cancel'),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconClose20NSvgDefault.default), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButton.ActionButton), {
                                            isQuiet: true,
                                            type: "submit",
                                            "aria-label": stringFormatter.format('table.save'),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconCheckmark20NSvgDefault.default), {})
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}
// Use color-mix instead of transparency so sticky cells work correctly.
const selectedBackground = "[light-dark(color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 10%), color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(93, 137, 255), rgb(52, 91, 248)) 10%))]";
const selectedActiveBackground = "[light-dark(color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 15%), color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(93, 137, 255), rgb(52, 91, 248)) 15%))]";
const rowBackgroundColor = {
    default: {
        default: 'gray-25',
        isQuiet: '--s2-container-bg'
    },
    isFocusVisibleWithin: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 7%)]",
    isHovered: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 7%)]",
    isPressed: "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 10%)]",
    isSelected: {
        default: selectedBackground,
        isFocusVisibleWithin: selectedActiveBackground,
        isHovered: selectedActiveBackground,
        isPressed: selectedActiveBackground // table-selected-row-background-color, opacity /15
    },
    forcedColors: {
        default: 'Background'
    }
};
const row = function anonymous(props) {
    let rules = " ";
    rules += ' Fb12';
    rules += ' _Pc12';
    rules += ' _oa12';
    rules += ' gs9yXOb12';
    if (props.isSelected) {
        if (props.isPressed) rules += ' -qH4xad-gT9rOHd12';
        else if (props.isHovered) rules += ' -qH4xad-gT9rOHd12';
        else if (props.isFocusVisibleWithin) rules += ' -qH4xad-gT9rOHd12';
        else rules += ' -qH4xad-gJpow3b12';
    } else if (props.isPressed) rules += ' -qH4xad-gRfT7e12';
    else if (props.isHovered) rules += ' -qH4xad-gj1B7i12';
    else if (props.isFocusVisibleWithin) rules += ' -qH4xad-gj1B7i12';
    else if (props.isQuiet) rules += ' -qH4xad-gEzkoQe12';
    else rules += ' -qH4xad-gX12';
    rules += ' -qH4xad-lga12';
    rules += ' -_34HbNb-Oh12';
    rules += ' -_34HbNb-lOc12';
    rules += ' _Le12';
    rules += ' _ka12';
    rules += ' hb12';
    rules += ' ma12';
    rules += ' la12';
    rules += ' _jf12';
    rules += ' iq12';
    rules += ' ila12';
    rules += ' _yb12';
    return rules;
};
const Row = /*#__PURE__*/ (0, _react.forwardRef)(function Row({ id, columns, children, dependencies = [], ...otherProps }, ref) {
    let { selectionBehavior, selectionMode } = (0, _reactAriaComponents.useTableOptions)();
    let tableVisualOptions = (0, _react.useContext)(InternalTableContext);
    let domRef = (0, _utils1.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Row), {
        // @ts-ignore
        ref: domRef,
        id: id,
        dependencies: [
            ...dependencies,
            columns
        ],
        className: (renderProps)=>row({
                ...renderProps,
                ...tableVisualOptions
            }) + (renderProps.isFocusVisible && " hFh6wc"),
        ...otherProps,
        children: [
            selectionMode !== 'none' && selectionBehavior === 'toggle' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Cell, {
                isSticky: true,
                className: checkboxCellStyle,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                    isEmphasized: true,
                    slot: "selection"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                items: columns,
                dependencies: [
                    ...dependencies,
                    columns
                ],
                children: children
            })
        ]
    });
});

},{"0":"3VutF","1":"yqPjZ","2":"g0H3Y","3":"8a76m","4":"6qZea","5":"kR5zi","6":"kdF7F","7":"aeVMr","8":"1GIK8","9":"hvwFm","10":"5zzDQ","11":"iKTQb","12":"aRkHz","13":"bIxFp","14":"5HTWf","15":"ae9cF","16":"2ibzh","17":"3fbiu","18":"3mKhs","19":"jfbTu","20":"kg5PW","21":"6HhyD","22":"8I1j0","23":"3z0Al","24":"39rAy","25":"cMGTg","26":"ecclZ","27":"kLEkN","28":"gnMdS","29":"kwYUy","react/jsx-runtime":"2Is6Z","./ActionButton":"lNDRs","react-aria-components":[["Button","9G5XO"],["ButtonContext","9G5XO"],["Cell","3vnUd"],["Column","3vnUd"],["ColumnResizer","3vnUd"],["ResizableTableContainer","3vnUd"],["Row","3vnUd"],["Table","3vnUd"],["TableBody","3vnUd"],["TableHeader","3vnUd"],["TableLoadMoreItem","3vnUd"],["useTableOptions","3vnUd"],["CheckboxContext","lIerG"],["Collection","2Jd0Q"],["DEFAULT_SLOT","bA6Cz"],["Provider","bA6Cz"],["useSlottedContext","bA6Cz"],["Form","g7RKA"],["OverlayTriggerStateContext","l2uUY"],["Popover","l4JC0"],["Rect","l3p76"],["TableLayout","dMZh4"],["Virtualizer","2WSF6"]],"./Checkbox":"jdSVu","../s2wf-icons/S2_Icon_Checkmark_20_N.svg":"1QXwE","../ui-icons/Chevron":"1904U","../s2wf-icons/S2_Icon_Close_20_N.svg":"aI18O","@react-aria/utils":[["getActiveElement","9OiSj"],["getOwnerDocument","fioCG"],["useLayoutEffect","2ViQu"],["useObjectRef","laqO5"]],"./Icon":"jQAJE","../intl/*.json":"gDH3q","./Menu":"1F0Yz","../ui-icons/S2_MoveHorizontalTableWidget.svg":"hoZMG","./ProgressCircle":"dztOy","react":"a1TxN","../s2wf-icons/S2_Icon_SortDown_20_N.svg":"ipfe6","../s2wf-icons/S2_Icon_SortUp_20_N.svg":"9pN2c","./ActionBar":"gU4lG","@react-spectrum/utils":"jqfrX","@react-aria/i18n":"7lxyl","./utils":"9papc","./useSpectrumContextProps":"8SU0q","react-aria":"7zrGr","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3VutF":[function() {},{}],"yqPjZ":[function() {},{}],"g0H3Y":[function() {},{}],"8a76m":[function() {},{}],"6qZea":[function() {},{}],"kR5zi":[function() {},{}],"kdF7F":[function() {},{}],"aeVMr":[function() {},{}],"1GIK8":[function() {},{}],"hvwFm":[function() {},{}],"5zzDQ":[function() {},{}],"iKTQb":[function() {},{}],"aRkHz":[function() {},{}],"bIxFp":[function() {},{}],"5HTWf":[function() {},{}],"ae9cF":[function() {},{}],"2ibzh":[function() {},{}],"3fbiu":[function() {},{}],"3mKhs":[function() {},{}],"jfbTu":[function() {},{}],"kg5PW":[function() {},{}],"6HhyD":[function() {},{}],"8I1j0":[function() {},{}],"3z0Al":[function() {},{}],"39rAy":[function() {},{}],"cMGTg":[function() {},{}],"ecclZ":[function() {},{}],"kLEkN":[function() {},{}],"gnMdS":[function() {},{}],"kwYUy":[function() {},{}],"hoZMG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2MoveHorizontalTableWidget = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 8,
                cy: 8,
                r: 8
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, #fff)",
                d: "M10 11.75a.75.75 0 0 1-.53-1.28L11.94 8 9.47 5.53a.75.75 0 1 1 1.06-1.06l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 0 1-.53.22M6 11.75a.75.75 0 0 1-.53-.22l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 1 1 1.06 1.06L4.06 8l2.47 2.47A.75.75 0 0 1 6 11.75"
            })
        ]
    });
exports.default = SvgS2MoveHorizontalTableWidget;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=ActionBar.4f72c269.js.map
